

var ticketButton = document.querySelector('.page-details__ticket-button');
if (ticketButton) {
  var ticketSelector = document.querySelector('.page-details__date-selector');

  ticketSelector.addEventListener('change', function() {
    if (ticketSelector.value === '') {
      ticketButton.setAttribute('disabled', 'disabled');
    } else {
      ticketButton.removeAttribute('disabled');
    }
  });

  ticketButton.addEventListener('click', function(event) {
    window.location.href = ticketSelector.value;
    event.preventDefault();
  });
}